import { useState } from "react";

const faqs = [
  {
    q: "吃瓜神器安卓手机版在哪里下载？",
    a: "建议直接使用本页「下载安卓安装包」入口获取，这是经过整理的稳定下载渠道。请避免从来历不明的论坛或网盘链接下载，以免安装到被篡改的版本。",
  },
  {
    q: "下载后提示「不允许安装未知来源应用」怎么办？",
    a: "这是安卓系统的正常安全机制。请在系统「设置 → 安全 → 安装未知应用」中，为你的文件管理或浏览器开启允许安装应用的权限，再重新点击安装包即可。",
  },
  {
    q: "吃瓜神器最新版是多少？如何升级？",
    a: "当前最新版本为 v5.2.1。你可以打开应用查看更新提醒，或在「设置 → 版本更新」页查看更新说明并下载最新安装包；也可以在本页版本更新区了解每次更新的内容。",
  },
  {
    q: "安装完成后打开闪退或无法登录怎么办？",
    a: "建议先尝试卸载后重新安装最新版本，并确认手机系统在安卓 6.0 及以上。若问题依旧，可清理应用缓存后重试，或稍后再试，等待服务恢复。",
  },
  {
    q: "吃瓜神器的瓜事信息真实可靠吗？",
    a: "应用会尽量标注每条信息的来源与发布时间，帮助你判断可信度。但网络信息复杂，对于未经证实的传闻建议理性看待，不轻信、不传播未经核实的消息。",
  },
  {
    q: "是否需要付费或购买会员才能使用？",
    a: "基础下载与使用完全免费，无需付费解锁核心功能。请认准官方入口，谨防任何以「开通会员」为由索要费用的假冒渠道。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full border-t border-background-200 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="mb-10 text-center md:mb-12">
          <span className="inline-flex items-center rounded-full bg-accent-50 px-3 py-1 text-xs font-bold text-accent-700">
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            关于下载与安装，你可能想知道
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            汇总了大家最常遇到的问题与解决办法，如果这里没有你要的答案，欢迎通过底部邮箱联系咨询。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, i) => {
            const active = open === i;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(active ? null : i)}
                  aria-expanded={active}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-base font-semibold text-foreground-950">{item.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${
                      active ? "rotate-180 bg-accent-100 text-accent-700" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    active ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}